import React, { useState, useEffect, useCallback } from "react";
// import { useSelector } from 'react-redux'
import {
  Dialog,
  IconButton,
  DialogTitle,
  DialogContent,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";

import "../contactos/modalContacts.css";

import { Tasks } from "../../models/tasks";
import { SeccionGeneral } from "./SeccionGeneral";
import { Model } from "../../models/model";

export const DialogFormTask = ({
  open,
  setOpen,
  taskId = null,
  refreshObj = null,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // móvil: sm o menor

  const [previuosInfo, setPreviuosInfo] = useState({});
  const [labelsList, setLabelsList] = useState([]);

  const [form, setForm] = useState({
    id: taskId || 0,
    tipo: refreshObj?.filters_?.id_ppto ? "hito" : "task",
    type: refreshObj?.filters_?.id_ppto ? "hito" : "task",
    origen: refreshObj?.filters_?.id_ppto ? "ppto" : null,
    id_origen: refreshObj?.filters_?.id_ppto || null,
    nombre: "",
    created: false,
    fecha_inicio: "",
    fecha_fin: "",
    date_change_option: "esta_tarea",
    labels: [],
    files: [],
  });

  const handleGetTask = useCallback(async () => {
    if (parseInt(taskId) > 0) {
      const resultTask = await Model.getOne({ url: `tasks/${taskId}` });

      setForm((prev) => ({
        ...prev,
        ...resultTask,
        date_change_option: "esta_tarea",
      }));

      setPreviuosInfo(resultTask);
    }
  }, [taskId]);

  const handleGetLabels = async () => {
    const resultslabels = await Model.getAll({ url: "labels" });
    setLabelsList(resultslabels || []);
  };

  const handleChange = async ({ target }) => {
    const { name, value, type, checked } = target;
    const newValue = type === "checkbox" ? checked : value;

    setForm((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  const handleChangeDate = (newDates) => {
    setForm((prev) => ({
      ...prev,
      fecha_inicio: newDates.fecha_inicio,
      fecha_fin: newDates.fecha_fin,
      edit_end_date: true,
      change_days: true,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (form.nombre === "") {
      toast.warn("Ingrese nombre tarea");
      return false;
    }

    if (form.id > 0) {
      await Tasks.update(form);
    } else {
      await Tasks.save(form);
      setForm({
        ...form,
        nombre: "",
      });
    }

    if (refreshObj) {
      await refreshObj.fn_(refreshObj.filters_);
    }
  };

  useEffect(() => {
    handleGetTask();
  }, [handleGetTask]);

  useEffect(() => {
    if (parseFloat(taskId) > 0) {
      handleGetLabels();
    }
  }, [taskId]);

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="simple-dialog-title"
      fullScreen={isMobile}
      PaperProps={{
        className: isMobile ? "" : "min-w-fit",
      }}
    >
      <div
        className={!isMobile ? `ContainerDialogs` : ""}
        style={{ width: !isMobile ? "700px" : "" }}
      >
        <DialogTitle
          id="scroll-dialog-title"
          style={{ position: "absolute", right: "0px", top: "0px" }}
        >
          <IconButton
            aria-label="close"
            style={{ padding: "0", float: "right" }}
            onClick={() => setOpen(false)}
          >
            <CloseIcon style={{ color: "#78667E" }} />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <SeccionGeneral
            form={form}
            setForm={setForm}
            handleChange={handleChange}
            handleChangeDate={handleChangeDate}
            handleSubmit={handleSubmit}
            handleInitGetTasks={() => false}
            refreshObj={refreshObj ? refreshObj : () => false}
            previuosInfo={previuosInfo}
            labelsList={labelsList}
          />
        </DialogContent>
      </div>
    </Dialog>
  );
};
